<div class="educations-content">
  @if(isEducationSectionView){
    @if (academic()?.educations?.length > 0) {
      <h2>Education</h2>
    }
    @for (item of academic()?.educations; track $index) {
      <div class="course-item">
        <label class="course-label">{{ item?.course }}</label>
        <label class="school-label"
          >{{ item?.schoolLabel }} | {{ item?.yearGraduated }}</label
          >
          <label class="educational-attainment">{{
            item?.educationalAttainmentLabel
          }}</label>
          @if (item?.additionalInfo !== '' && item?.additionalInfo !== null) {
            <p>
              {{ item?.additionalInfo }}
            </p>
          }
        </div>
        } } @if(isAwardsSectionView){
        @if (academic()?.awardHonors?.length > 0) {
          <h3>Awards and Honors</h3>
        }
        @for (item of academic()?.awardHonors; track $index) {
          <div class="awards-item">
            <label class="awards-title"> {{ item.title }} </label>
            <label class="date-acquired">
              {{ item.dateAcquired | date : 'yyyy' }}
            </label>
            @if (item.description !== '' && item.description !== null) {
              <p
                class="educational-attainment"
                >
                {{ item.description }}
              </p>
            }
          </div>
          } } @if(isCertificationSectionView){
          @if (academic()?.certificationLicense?.length > 0) {
            <h3>
              Licenses and Certifications
            </h3>
          }
          @for (item of academic()?.certificationLicense; track $index) {
            <div class="certifications-item">
              <label class="certification-label">{{
                item.certificationLicenseLabel
              }}</label>
              <label class="cert-date-acquired">{{
                item.dateAcquired | date : 'yyyy'
              }}</label>
            </div>
            } }
          </div>
